import { HttpBadStatusCodeError } from '@cian/peperrors/shared';

import { createAboutNearbyHousesMapper, TMappedResponse } from './mappers';
import {
  fetchNearbyHousesExplanation,
  INearbyHousesExplanationRequest,
} from '../../../repositories/valuation-offer-history/v1/nearby-houses-explanation';
import { TAboutNearbyHousesData } from '../../../store/offerHistory';
import { IApplicationContext } from '../../../types/applicationContext';

export const fetchNearbyHousesInfo = async (
  context: IApplicationContext,
  { offerId }: IParams,
): Promise<TAboutNearbyHousesData> => {
  const parameters: INearbyHousesExplanationRequest = { offerId };

  try {
    const res = (await fetchNearbyHousesExplanation({
      httpApi: context.httpApi,
      parameters,
      mappers: createAboutNearbyHousesMapper(parameters),
    })) as TMappedResponse;

    if (HttpBadStatusCodeError.is(res)) {
      throw res;
    }

    return res;
  } catch (error) {
    if (HttpBadStatusCodeError.is(error)) {
      context.logger.debug('nearby-houses-explanation BadRequest', { details: error.printDetails() });
    } else {
      context.logger.error(error, { message: 'Error in nearby-houses-explanation', ...parameters });
    }

    throw error;
  }
};

export interface IParams {
  offerId: number;
}
